import { forwardRef } from "react"

import { PureTextProps } from "./PureTextProps"

import styles from "./styles.module.scss"

const PureText = ({ value, prefix, formatter = (value) => value }: PureTextProps, ref: any) => {
  return (
    <div ref={ref} className={styles["container"]}>
      {prefix && <span>{prefix}</span>}
      <span>{formatter(value)}</span>
    </div>
  )
}

export default forwardRef(PureText)
